import qs from "qs";

export const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_ENDPOINT || "http://localhost:1337";
export const STRAPI_CDN_URL =
  process.env.REACT_APP_CDN_URL || "http://localhost:1337/uploads";

export async function getProyectoDetalle() {
  try {
    const query = qs.stringify({
      populate: "*",
      sort: ["id:asc"],
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/plg-proyectoss?${query}`);
    if (!res.ok) throw new Error(`Error en la petición: ${res.status}`);

    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Error cargando proyecto:", err);
    return [];
  }
}